import type { EventMapViewportTransform } from '~/shared-kernel/presentation/event-map/event-map.types'

export interface EventMapGesturePoint {
  x: number
  y: number
}

export interface EventMapPinchGesture {
  center: EventMapGesturePoint
  distance: number
}

export const EVENT_MAP_DEFAULT_MIN_ZOOM = 0.25
const MAX_ZOOM = 4

export function eventMapZoomAround(
  viewport: EventMapViewportTransform,
  nextZoom: number,
  anchor: EventMapGesturePoint,
  minZoom = EVENT_MAP_DEFAULT_MIN_ZOOM
): EventMapViewportTransform {
  const zoom = Math.min(MAX_ZOOM, Math.max(minZoom, nextZoom))
  const worldX = (anchor.x - viewport.panX) / viewport.zoom
  const worldY = (anchor.y - viewport.panY) / viewport.zoom

  return {
    zoom,
    panX: anchor.x - worldX * zoom,
    panY: anchor.y - worldY * zoom
  }
}

export function eventMapPinchGesture(first: EventMapGesturePoint, second: EventMapGesturePoint): EventMapPinchGesture {
  return {
    center: {
      x: (first.x + second.x) / 2,
      y: (first.y + second.y) / 2
    },
    distance: Math.hypot(second.x - first.x, second.y - first.y)
  }
}

export function eventMapPinchViewport(
  viewport: EventMapViewportTransform,
  previous: EventMapPinchGesture,
  current: EventMapPinchGesture,
  minZoom = EVENT_MAP_DEFAULT_MIN_ZOOM
): EventMapViewportTransform {
  if (previous.distance <= 0 || current.distance <= 0) return viewport

  const worldX = (previous.center.x - viewport.panX) / viewport.zoom
  const worldY = (previous.center.y - viewport.panY) / viewport.zoom
  const zoom = Math.min(MAX_ZOOM, Math.max(minZoom, viewport.zoom * current.distance / previous.distance))

  return {
    zoom,
    panX: current.center.x - worldX * zoom,
    panY: current.center.y - worldY * zoom
  }
}
